import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'alert-box',
    template: require('./alert-box.component.html')
})
export class AlertBoxComponent {
    @Output() public dismissMessage: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() private message: string;

    constructor() { }

    private hideMessage(): void {
        this.dismissMessage.emit();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/alert-boxes/alert-box.component.ts